const inRangeValidator = (minValue, maxValue) => ({
    name: "in-range",
    validate: (v) => v == null || (v >= minValue && v <= maxValue),
    getMessage: () => `The value must be ${minValue} - ${maxValue}`,
});
exports.inRangeValidator = inRangeValidator;
